<template>
  <div class="myParentDiv">
    <van-sticky>
    <div class="topDiv">
      <div style="display: flex;flex-direction: row;align-items: center;">
        <div style="display: flex;flex-direction: row;align-items: center;">
          <HAvatar @click="clickAvatar" style="margin-right: 10px;"/>
          <div style="display: flex;flex-direction: column;align-items: flex-start;">
            <div style="display: flex;flex-direction: row;align-items: center;">
              <div @click="clickAvatar" :style="hcf.getTextStyle({
            addSize:2,color:useUser.isLogin?'#333333':'main'})">
                {{ useUser.isLogin ? hcf.getShowNamePhoneId(useUser) : "登录/注册" }}
              </div>
              <img v-if="useUser.isLogin" @click="clickAvatar" :src="icon_editProfile" height="20px;" alt=""
                   style="margin-left: 10px;">
            </div>
            <HShowRefreshBalance v-if="useUser.isLogin" moneyColor="#E08900"/>
          </div>
        </div>
        <div style="flex:1"/>
        <img @click="useUser.checkIsLoginGo('setting');" :src="icon_setting" height="21px;" alt="">
        <img @click="()=>{showToast('暂无消息');}" :src="icon_msg" height="21px;" style="margin:0 15px" alt="">
      </div>
      <div
          style="display: flex;flex-direction: row;padding:15px 10px 0 10px;align-items: center;justify-content: space-around">
        <div @click="item.callBack" v-for="item in threeBtnInfos" :key="item.title" style="
        display: flex;flex-direction: column;align-items: center;justify-content: center;
      ">
          <img v-if="item.title!=='|'" :src="item.icon" height="30px" alt="">
          <div v-if="item.title!=='|'" :style="hcf.getTextStyle({
            color:'#5C6293'})">
            {{ item.title }}
          </div>
          <div v-if="item.title === '|'"
               style="display: flex; border-radius: 3px; width:1.5px;align-items: center; height: 100%;background-color: white;">
            <div style="width: 1px; height: 26px; border-radius: 3px;background-color: #AEB9E8;"/>
          </div>
        </div>
      </div>
    </div>
    </van-sticky>
    <div v-if="useUser.isLogin" @click="()=>{hr.go('vip');}" :style='{
      backgroundImage:`url(${iconVipBg})`,
      backgroundRepeat: "no-repeat",
      height:"58px",
      backgroundSize: "100% 100%",
      backgroundPosition: "left",
      padding:"10px",
      display:"flex",
      flexDirection:"row",
      flex:"1",
      justifyContent:"space-between",
      alignItems:"center",
    }'>
        <img :src="iconVipLeft" style="height:38px;" alt="">
        <div style="display: flex;flex-direction:column;align-items: flex-start;justify-content: center;flex:1;">
          <div style="display: flex;flex-direction:row;align-items: center;justify-content: space-between;flex:1;width:100%;">
            <div :style='{
              backgroundImage:`url(${iconVipLevelBg})`,
              backgroundRepeat: "no-repeat",
              height:"22px",
              backgroundSize: "auto 100%",
              width:292/90*22+"px",
              backgroundPosition: "left",
              display:"flex",
              flexDirection:"row",
              alignItems:"center",
              justifyContent:"center",
            }'>
              <div :style="hcf.getTextStyle({
                addSize:3,color:'white',fontWeight:'bold'
              })">
                VIP.{{useUser.vipLevel}}
              </div>
            </div>
            <div style="display:flex;flex-direction: row;align-items: center;">
              <div :style="hcf.getTextStyle({
                color:'#8A604B',fontWeight:'bold',addSize:-1
              })">
                距离
              </div>
              <div :style="hcf.getTextStyle({
                color:'#DC2B2B',fontWeight:'bold',marginLeft:5,marginRight:5,addSize:-1
              })">
                VIP{{useUser.vipLevel+1}}
              </div>
              <div :style="hcf.getTextStyle({
                color:'#8A604B',fontWeight:'bold',addSize:-1
              })">
                打码还差
              </div>
              <div :style="hcf.getTextStyle({
                color:'black',fontWeight:'bold',marginLeft:5,addSize:-1
              })">
                {{useUser.nextExp-useUser.currentExp}}
              </div>
            </div>
          </div>
          <div style="width:100%;margin-top:8px;">
            <van-progress
                style="background-color: #fff;height:5px;"
                :percentage="showProgressValue"
                :pivot-text="showProgressText"
                pivot-color="#FFBC90"
                text-color="#a00"
                color="linear-gradient(to right, #FFBC90, #EABC90)"
            />
          </div>
        </div>
      </div>
    <div
        style="background-color: white;display: flex;flex-direction: row;padding:10px;align-items: center;justify-content: space-around">
      <div @click="item.callBack" v-for="item in fourBtnInfos" :key="item.title" style="
        display: flex;flex-direction: column;align-items: center;justify-content: center;
      ">
        <img v-if="item.title!=='|'" :src="item.icon" height="30px" alt="">
        <div v-if="item.title!=='|'" :style="hcf.getTextStyle()">
          {{ item.title }}
        </div>
        <div v-if="item.title === '|'"
             style="display: flex; border-radius: 3px; width:1.5px;align-items: center; height: 100%;background-color: white;">
          <div style="width: 1px; height: 26px; border-radius: 3px;background-color: #AEB9E8;"/>
        </div>
      </div>
    </div>
    <HCellGroup :data="cellGroupData"/>
    <HCellGroup :data="cellGroupData15"/>
    <HCellGroup :data="cellGroupData2"/>
  </div>
</template>


<script setup>
  import {useUserStore} from "@/stores/useUser.js";
  import {showToast} from "vant";
  import HAvatar from "@/components/utils/HAvatar.vue";
  import {hcf} from "@/components/utils/HComFunctions.js";
  import {hr} from "@/components/utils/HRouter.js";
  import HShowRefreshBalance from "@/components/utils/HShowRefreshBalance.vue";
  import icon_setting from '@/assets/icons/my/top_icon_setting.png';
  import icon_msg from '@/assets/icons/my/top_icon_msg.png';
  import icon_editProfile from '@/assets/icons/my/editor_userinfo.png';

  import top_icon_pay from '@/assets/icons/my/top_icon_pay.png';
  import top_icon_get from '@/assets/icons/my/top_icon_get.png';
  import top_icon_vip from '@/assets/icons/my/top_icon_vip.png';

  import user_detail from '@/assets/icons/my/user_detail.png';
  import bet_history from '@/assets/icons/my/bet_history.png';
  import user_table from '@/assets/icons/my/user_table.png';
  import user_get_mgr from '@/assets/icons/my/user_get_mgr.png';

  import icon_netState from '@/assets/icons/my/icon_netstate.png';
  import icon_accountSafe from '@/assets/icons/my/icon_accountsafe.png';
  import icon_checkVersion from '@/assets/icons/my/icon_checkversion.png';
  import icon_aboutUs from '@/assets/icons/my/icon_aboutus.png';
  import icon_tools from '@/assets/icons/my/icon_tools.png';

  import iconVipBg from '@/assets/icons/my/vip_item_bg.png';
  import iconVipLeft from '@/assets/icons/my/vip_item_left.png';
  import iconVipLevelBg from '@/assets/icons/my/vip_level_bg.png';

  import {hdi} from "@/components/utils/HDeviceInfo.js";
  import axios from "axios";
  import {useHHttp} from "@/hooks/useHHttp.js";
  const useUser = useUserStore();
  let useHttp = useHHttp();

  let showProgressText = computed(()=>{
    return useUser.currentExp+"/"+useUser.nextExp;
  });
  let showProgressValue = computed(()=>{
    let result = useUser.currentExp/useUser.nextExp*100;
    if(result<=0){
      result = 0;
    }
    if(result>=100){
      result = 100;
    }
    return result;
  });

  let threeBtnInfos = [
    {
      title: "充值",
      icon: top_icon_pay,
      callBack: () => {
        useUser.checkIsLoginGo("pay");
      },
    },
    {
      title: "|",
    },
    {
      title: "提现",
      icon: top_icon_get,
      callBack: () => {
        useUser.checkIsLoginGo("withdraw");
      },
    },
    {
      title: "|",
    },
    {
      title: "VIP",
      icon: top_icon_vip,
      callBack: () => {
        useUser.checkIsLoginGo("vip");
      },
    }
  ];
  let fourBtnInfos = [
    {
      title: "账户明细",
      icon: user_detail,
      callBack: () => {
        useUser.checkIsLoginGo("account-detail");
      },
    },
    {
      title: "投注记录",
      icon: bet_history,
      callBack: () => {
        useUser.checkIsLoginGo("bet-history");
      },
    },
    {
      title: "注单报表",
      icon: user_table,
      callBack: () => {
        showToast("功能升级中")
      },
    },
    {
      title: "提现管理",
      icon: user_get_mgr,
      callBack: () => {
        useUser.checkIsLoginGo("bind_card");
      },
    }
  ];
  const speed = ref(-1);
  function getSpeedColor() {
    if (speed.value === -2) {
      return "#f44336";
    } else if (speed.value === -1) {
      return hcf.getMainFontColor();
    } else if (speed.value <= 500) {
      return "#4CAF50";
    } else if (speed.value <= 1000) {
      return "#888800";
    } else {
      return "#D36914";
    }
  }
  let speedTimer = null;
  const cellGroupData = ref([]);


  const cellGroupData15 = ref([
    {
      "icon": icon_tools,
      "title": "实用工具下载",
      "rightText": "常用浏览器/钱包等",
      "callBack": () => {
        useUser.checkIsLoginGo("tools");
      }
    },
  ]);

  const cellGroupData2 = ref([
    {
      "icon": icon_checkVersion,
      "title": "检查更新",
      "rightText": hdi.appVersion,
      "callBack": () => {
        showToast("当前已是最新版本");
      }
    },
    {
      "icon": icon_aboutUs,
      "title": "关于我们",
      "rightText": "",
      "callBack": () => {
        hr.go("about");
      }
    },
  ]);


  function updateCellData() {
    cellGroupData.value = [
      {
        "icon": icon_netState,
        "title": "网络与设备",
        "rightText":
            speed.value === -1 ? "测速中..." : (speed.value+"ms"),
        "rightTextColor": getSpeedColor(),
        "callBack": () => {
          hr.go("device");
        }
      },
      {
        "icon": icon_accountSafe,
        "title": "账户与安全",
        "rightText": useUser.isLogin && useUser.checkCanOptimizationCount()>0?(useUser.checkCanOptimizationCount()+"项需要完善"):"",
        "rightTextColor": "#f44336",
        "callBack": () => {
          useUser.checkIsLoginGo("safe");
        },
      },
    ];
  }

  async function testSpeed() {
    let start = Math.floor(Date.now());
    try {
      await axios.get(useHttp.getServerUrlsConfig().ApiGw + "/api-speed");
    } catch (e) {
    }
    let end = Math.floor(Date.now());
    speed.value = end - start;
    updateCellData();
  }

  onActivated(()=>{
    testSpeed();
    speedTimer = setInterval(() => {
      testSpeed();
    }, 5000);
    updateCellData();
  });

  onDeactivated(() => {
    if (speedTimer) {
      clearInterval(speedTimer);
      speedTimer = null;
    }
  });

  function clickAvatar() {
    useUser.checkIsLoginGo('profile');
  }
</script>


<style scoped>
  .topDiv {
    padding: 10px;
    background-color: var(--ct-main-color-bg);
  }

  .myParentDiv {
    display: flex;
    flex-direction: column;
  }
</style>
